import { FACE_CONFIG } from './cube-config.js';

export const EDGE_NAMES = Object.freeze('UF UR UB UL DF DR DB DL FR FL BR BL'.split(' '));
export const CORNER_NAMES = Object.freeze('UFR URB UBL ULF DRF DFL DLB DBR'.split(' '));
export const CENTER_ORDER = Object.freeze(['U', 'L', 'F', 'R', 'B', 'D']);

// Each list is ordered exactly like the corresponding Reid piece name above.
// Facelets use the public Face + row-major index address system.
export const EDGE_FACELETS = Object.freeze({
  UF: Object.freeze([['U', 7], ['F', 1]]),
  UR: Object.freeze([['U', 5], ['R', 1]]),
  UB: Object.freeze([['U', 1], ['B', 1]]),
  UL: Object.freeze([['U', 3], ['L', 1]]),
  DF: Object.freeze([['D', 1], ['F', 7]]),
  DR: Object.freeze([['D', 5], ['R', 7]]),
  DB: Object.freeze([['D', 7], ['B', 7]]),
  DL: Object.freeze([['D', 3], ['L', 7]]),
  FR: Object.freeze([['F', 5], ['R', 3]]),
  FL: Object.freeze([['F', 3], ['L', 5]]),
  BR: Object.freeze([['B', 3], ['R', 5]]),
  BL: Object.freeze([['B', 5], ['L', 3]]),
});

export const CORNER_FACELETS = Object.freeze({
  UFR: Object.freeze([['U', 8], ['F', 2], ['R', 0]]),
  URB: Object.freeze([['U', 2], ['R', 2], ['B', 0]]),
  UBL: Object.freeze([['U', 0], ['B', 2], ['L', 0]]),
  ULF: Object.freeze([['U', 6], ['L', 2], ['F', 0]]),
  DRF: Object.freeze([['D', 2], ['R', 6], ['F', 8]]),
  DFL: Object.freeze([['D', 0], ['F', 6], ['L', 8]]),
  DLB: Object.freeze([['D', 6], ['L', 6], ['B', 8]]),
  DBR: Object.freeze([['D', 8], ['B', 6], ['R', 8]]),
});

export const COLOR_TO_FACE = Object.freeze(Object.fromEntries(
  Object.entries(FACE_CONFIG).map(([face, config]) => [config.color, face]),
));

export const FACE_TO_COLOR = Object.freeze(Object.fromEntries(
  Object.entries(FACE_CONFIG).map(([face, config]) => [face, config.color]),
));

export const OPPOSITE_FACE = Object.freeze({ U: 'D', D: 'U', R: 'L', L: 'R', F: 'B', B: 'F' });

export function pieceKey(faceLetters) {
  return [...faceLetters].sort().join('');
}

export const EDGE_PIECE_BY_KEY = Object.freeze(Object.fromEntries(
  EDGE_NAMES.map((name, index) => [pieceKey(name), index]),
));

export const CORNER_PIECE_BY_KEY = Object.freeze(Object.fromEntries(
  CORNER_NAMES.map((name, index) => [pieceKey(name), index]),
));
